import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './auth/auth.guard';
import { CanDeactivateGuard } from './auth/deactivate.guard';

const routes: Routes = [
  { 
    path: 'home'    , 
    component: HomeComponent, 
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard] 
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'gestio',
    loadChildren: () => import('./gestio/gestio.module').then(m => m.GestioModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'gitih',
    loadChildren: () => import('./gitih/gitih.module').then(m => m.GitihModule),
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: 'gitih' }
];

  // imports: [ RouterModule.forRoot(routes, {useHash: true}) ],
  @NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ],
    providers: [ CanDeactivateGuard ]
  })
export class AppRoutingModule { }
